import React from 'react'

function Contact(props){
	return(<header className="con"><h2>{props.head}</h2><p> {props.num1}<br/>{props.num2}<br/>{props.num3}</p> </header>);
}




export default Contact;